import { render, staticRenderFns } from "./penaltyGroupByType.vue?vue&type=template&id=b20daedc&"
import script from "./penaltyGroupByType.vue?vue&type=script&lang=js&"
export * from "./penaltyGroupByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports